import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10","key":"svg-0"}],["path",{"d":"M12 10v-7","key":"svg-1"}]]

const IconGenderNeutrois = createReactComponent('outline', 'gender-neutrois', 'GenderNeutrois', __iconNode);

export default IconGenderNeutrois;